<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>SATGAS REPORT</h4>
			</div>

			<div class="col-md-12 mb-3">
				<el-row class="scrollable-row">
					<el-button :type="tabIndex == index ? 'primary' : 'plain'" class="" size="medium" v-for="(item, index) in tabList" :key="'btn-tab-'+index" @click="selectTab(index)"> <i class="fa fa-angle-down"></i> &nbsp; {{ item.label }}</el-button>
				</el-row>
			</div>

			<div class="col-md-12 mb-2">
				<el-card shadow="never" class="box-card col-md-12 mb-0" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
					<div>
						<div v-for="(item, index) in tabList" :label="item.label" :name="item.index" :key="index" >
							<SatgasReportTab v-show="tabIndex == index" :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" :tabTitle="item.title" :showTitle="true"/>
						</div>
					</div>
				</el-card>
			</div>

			<div class="col-md-12" v-if="false">
				<div class="card cardptpr mb-4">
					<div class="card-header p-3 pb-0 pt-0">
						<H6>SATGAS REPORT</H6>
					</div>
					<div class="card-body p-3 pt-4">
						<el-tabs type="border-card" v-model="tabIndex" @tab-click="handleTabClick">
							<el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
								<SatgasReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label"/>
							</el-tab-pane>
						</el-tabs>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>

import Fuel from '@/components/page/Fuel.js'
import SatgasReportTab from '@/views/pages/SatgasReportTab.vue'


export default
{
	extends:Fuel,
	components: {
		SatgasReportTab,
	},
	data() {
		return {
			tabList:[
				/*
				{name:'Sales'},
				{name:'Losses'},
				{name:'Payment'},
				{name:'Stock'},
				//{name:'shift'},
				//{name:'transaction'},
				//{name:'tank delivery'},
				//{name:'oil flow'},
				*/
				{label:'Sales', name: 'sales', index: '0', title:'Sales Satgas Modular' },
				{label:'Sales BBK Kemasan', name: 'sales_kemasan', index: '9', title:'Sales BBK Kemasan' },
				{label:'Losses', name: 'losses', index: '1', title:'Losses Satgas Modular' },
				{label:'Payment', name: 'payment', index: '2', title:'Payment Satgas Modular' },
                {label:'Stock', name: 'stock', index: '3', title:'Stock Satgas Modular' },
				{label:'Status Pekerja', name: 'absen', index: '4', title:'Status Pekerja' },
				/*
                {label:'Shift', name: '4'},
                {label:'Transaction', name: '5'},
				{label:'Tank delivery', name: '6'},
				{label:'Oil Flow', name: '7'},
				*/
				{label:'Stock BBK Kemasan', name: 'stock_kemasan', index: '8', title:'Stock BBK Kemasan'  },
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '0',

		}
	},

	watch: {

	},
	mounted() {
		this.$emit('childrenRoute')
	},
	methods: {
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

		selectTab(index) {
			this.tabIndex = `${index}`; //String(index);
			//console.log('index: ' + index);
		}

	},

}
</script>

<style>


</style>
